export default __webpack_public_path__ + "static/media/IPAC-talks.fd21b75d.png";